class AeFileUpload extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.provider = this.querySelector('uc-upload-ctx-provider');
    this.submitButton = this.querySelector('[data-ae-upload-submit]');
    this.statusElement = this.querySelector('[data-ae-upload-status]');
    this.fileUrlInput = this.querySelector('[data-ae-upload-url]');
    this.fileNameInput = this.querySelector('[data-ae-upload-name]');
    this.fileSizeInput = this.querySelector('[data-ae-upload-size]');
    this.fileUuidInput = this.querySelector('[data-ae-upload-uuid]');
    this.orderInput = this.querySelector('[data-ae-order-input]');
    this.emailInput = this.querySelector('[data-ae-email-input]');
    this.maxFileSizeLabel = this.dataset.maxFileSizeLabel || '1 GB';

    this.prefillFromUrl();
    this.bindEvents();
    this.updateSubmitState();
  }

  bindEvents() {
    if (this.provider) {
      this.provider.addEventListener('file-added', () => {
        this.clearFileFields();
        this.setStatus('Filen klargjøres for opplasting.');
      });

      this.provider.addEventListener('file-upload-start', () => {
        this.clearFileFields();
        this.setStatus('Laster opp filen. Hold siden åpen til opplastingen er ferdig.');
      });

      this.provider.addEventListener('common-upload-progress', (event) => {
        const progress = Math.round((event.detail?.progress || 0) * 100);
        if (progress > 0 && progress < 100) this.setStatus(`Laster opp filen: ${progress}%`);
      });

      this.provider.addEventListener('file-upload-success', (event) => {
        this.setFileFields(event.detail);
      });

      this.provider.addEventListener('file-removed', () => {
        this.clearFileFields();
        this.setStatus('Velg én fil før du sender inn skjemaet.');
      });

      this.provider.addEventListener('file-upload-failed', () => {
        this.clearFileFields();
        this.setStatus(`Filen kunne ikke lastes opp. Sjekk at filen er under ${this.maxFileSizeLabel}.`);
      });
    }

    if (this.form) {
      this.form.addEventListener('submit', (event) => {
        if (!this.fileUrlInput?.value) {
          event.preventDefault();
          this.setStatus('Last opp filen før du sender inn skjemaet.');
          this.updateSubmitState();
        }
      });
    }
  }

  prefillFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const order = params.get('order') || params.get('ordrenummer');
    const email = params.get('email') || params.get('e-post');

    if (order && this.orderInput && !this.orderInput.value) this.orderInput.value = order;
    if (email && this.emailInput && !this.emailInput.value) this.emailInput.value = email;
  }

  setFileFields(fileEntry) {
    const fileUrl = fileEntry?.cdnUrl || '';

    if (this.fileUrlInput) this.fileUrlInput.value = fileUrl;
    if (this.fileNameInput) this.fileNameInput.value = fileEntry?.name || '';
    if (this.fileSizeInput) this.fileSizeInput.value = this.formatBytes(Number(fileEntry?.size || 0));
    if (this.fileUuidInput) this.fileUuidInput.value = fileEntry?.uuid || '';

    this.setStatus(fileUrl ? 'Filen er lastet opp. Send inn skjemaet for å koble den til ordren.' : 'Filen mangler lenke. Prøv å laste opp på nytt.');
    this.updateSubmitState();
  }

  clearFileFields() {
    if (this.fileUrlInput) this.fileUrlInput.value = '';
    if (this.fileNameInput) this.fileNameInput.value = '';
    if (this.fileSizeInput) this.fileSizeInput.value = '';
    if (this.fileUuidInput) this.fileUuidInput.value = '';
    this.updateSubmitState();
  }

  updateSubmitState() {
    if (!this.submitButton) return;

    const hasFile = Boolean(this.fileUrlInput?.value);
    this.submitButton.disabled = !hasFile;
    this.submitButton.textContent = hasFile ? 'Send filinformasjon' : 'Last opp fil først';
  }

  formatBytes(bytes) {
    if (!Number.isFinite(bytes) || bytes <= 0) return '';

    const units = ['B', 'KB', 'MB', 'GB', 'TB'];
    const exponent = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
    const value = bytes / 1024 ** exponent;

    return `${value.toFixed(value >= 10 ? 0 : 1)} ${units[exponent]}`;
  }

  setStatus(message) {
    if (this.statusElement) this.statusElement.textContent = message;
  }
}

if (!customElements.get('ae-file-upload')) {
  customElements.define('ae-file-upload', AeFileUpload);
}
